module.exports = __webpack_public_path__ + "img/208.ebd572cf.png";